import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IPostUser } from '../models/response/getUserListResponseModel'

export class UpdateUserApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/user/update',
      requesterInfo,
    })
  }

  public async updateUser(user: IPostUser): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(user)
  }
}
